// Auto-generated by splitter.py — do not regenerate; edit directly.

import React, { useState } from 'react';
import { toast } from '../../lib/buses';
import { Modal } from '../../ui/Modal';

export const NoteComposerModal = ({ open, onClose, context, contextLabel, onSave }) => {
  const [body, setBody] = useState('');
  const [pinned, setPinned] = useState(false);
  const [audience, setAudience] = useState('ops');
  // Adjust state during render (not in an effect) when `open` changes — see
  // react.dev "Adjusting some state when a prop changes".
  const [prevOpen, setPrevOpen] = useState(open);
  if (open !== prevOpen) {
    setPrevOpen(open);
    if (!open) { setBody(''); setPinned(false); setAudience('ops'); }
  }
  if (!open) return null;
  return (
    <Modal open={open} onClose={onClose} width="max-w-[520px]" title="Add internal note" sub={contextLabel ? `On ${contextLabel}` : null}>
      <div className="space-y-3">
        <div>
          <label className="block text-[11px] font-medium text-[#1F2937] mb-1.5">Note</label>
          <textarea value={body} onChange={e => setBody(e.target.value)} rows={5} autoFocus placeholder="What changed, what to watch, who to follow up with…" className="w-full bg-white border border-[#E6E4E1] rounded-md px-2.5 py-2 text-[12.5px] focus:outline-none focus:border-[#D8D5CF] resize-none" />
          <div className="text-[10.5px] text-[#9CA3AF] mt-1">Visible only to TKT staff. Cited in the audit trail.</div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-[11px] font-medium text-[#1F2937] mb-1.5">Audience</label>
            <select value={audience} onChange={e => setAudience(e.target.value)} className="w-full h-9 bg-white border border-[#E6E4E1] rounded-md px-2.5 text-[12.5px] focus:outline-none focus:border-[#D8D5CF]">
              <option value="ops">Operations team</option>
              <option value="finance">Finance team</option>
              <option value="risk">Risk &amp; compliance</option>
              <option value="all">All TKT staff</option>
            </select>
          </div>
          <div className="flex items-end">
            <label className="flex items-center gap-2 text-[12px] text-[#4B5563] cursor-pointer">
              <input type="checkbox" checked={pinned} onChange={e => setPinned(e.target.checked)} />
              Pin to top of timeline
            </label>
          </div>
        </div>
      </div>
      <div className="px-5 py-3 border-t border-[#EEEDEA] bg-[#FBFAF7] -mx-5 -mb-4 mt-4 flex items-center justify-end gap-1.5 gap-y-2 flex-wrap">
        <button onClick={onClose} className="h-8 px-3 text-[12px] font-medium rounded-md text-[#1F2937] hover:bg-[#F2F1ED]">Cancel</button>
        <button onClick={() => { onSave && onSave({ body, audience, pinned, context }); toast('Note saved', 'success', contextLabel || 'Note added to timeline'); onClose(); }} disabled={!body.trim()} className="h-8 px-3 text-[12px] font-medium rounded-md bg-[#1F2937] hover:bg-[#111827] disabled:bg-[#9CA3AF] text-white">Save note</button>
      </div>
    </Modal>
  );
};

